/**
 * Created by zack on 2016/7/25.定义突变
 */
export const SHOW_TOAST = 'SHOW_TOAST'
export const HIDE_TOAST = 'HIDE_TOAST'
export const LOGIN_SUCCEED = 'LOGIN_SUCCEED'
export const FETCH_COLLEGE_INFO = 'FETCH_COLLEGE_INFO'
export const FETCH_INSTANCE_INFO = 'FETCH_INSTANCE_INFO'
export const FETCH_INSTANCE_TITLE = 'FETCH_INSTANCE_TITLE'
export const FETCH_EXPERT_INFO = 'FETCH_EXPERT_INFO'
export const FETCH_EXPERT_LIST = 'FETCH_EXPERT_LIST'
export const FETCH_EXPERT_QUESTION = 'FETCH_EXPERT_QUESTION'
export const FETCH_USER_QUESTION = 'FETCH_USER_QUESTION'
// export const SUBMIT_QUESTION = 'SUBMIT_QUESTION'
export const FETCH_ENROLLPLAN = 'FETCH_ENROLLPLAN'
export const FETCH_ENROLLRESULT = 'FETCH_ENROLLRESULT'
export const FETCH_RESOURCE_DETAIL = 'FETCH_RESOURCE_DETAIL'
export const FETCH_COMMON_PROLEM = 'FETCH_COMMON_PROLEM'
export const CONFIRM_ORDER = 'CONFIRM_ORDER'
export const LOGIN_SUCCEED_FROMSWYT = 'LOGIN_SUCCEED_FROMSWYT'
export const CUEEENT_TAB = 'CUEEENT_TAB'
export const LOGIN_FAILED = 'LOGIN_FAILED'
// class10
export const FETCH_ENROLLPLAN_TAB = 'FETCH_ENROLLPLAN_TAB'
export const FETCH_ENROLLPLAN_DATA = 'FETCH_ENROLLPLAN_DATA'
// class11
export const FETCH_ENROLLRESULT_TAB = 'FETCH_ENROLLRESULT_TAB'
export const FETCH_ENROLLRESULT_DATA = 'FETCH_ENROLLRESULT_DATA'
// class4
export const FETCH_RESOURCE = 'FETCH_RESOURCE'
// class13
export const FETCH_MAJOR = 'FETCH_MAJOR'
export const GET_WEIXIN = 'GET_WEIXIN'
export const GET_HTML = 'GET_HTML'

export const SET_BANNER = 'SET_BANNER'

// IP
export const SET_IP_ADDRESS = 'SET_IP_ADDRESS'
// 小程序码
export const GET_MINI_PROGRAM = 'GET_MINI_PROGRAM'



// WEBPACK FOOTER //
// ./src/store/modules/common/mutation-types.js